import { useEffect } from 'react';
// React Router
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// Page
import { Login } from './Page/Login';
import { List } from './Page/List';
import { New } from './Page/New';
import { Users } from './Page/Users';
import { Views } from './Page/Views';
// i18
import { useTranslation } from 'react-i18next';
// Config
import { getConfig } from './config';

function App() {
    document.documentElement.style.setProperty('--color-primario', getConfig('colorPrimario'));

    const { i18n } = useTranslation(["translation"]);
    useEffect(() => {
        if(localStorage.getItem("lang")==="true") {
            i18n.changeLanguage("es");
        }
        else {
            i18n.changeLanguage("en");
        }
    }, [])

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/list" element={<List />} />
                <Route path="/new" element={<New />} />
                <Route path="/users" element={<Users />} />
                <Route path="/views" element={<Views />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
